import { adminCall, adminGet } from '../../../api/adminCall';

export async function getPlatformSendGridSettings() {
  return adminGet('/api/admin/platform/sendgrid');
}

export async function setPlatformSendGridSettings(payload) {
  const data = await adminCall('/api/admin/platform/sendgrid', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to save SendGrid settings');
  return data;
}

export async function testPlatformSendGridSettings({ to } = {}) {
  const data = await adminCall('/api/admin/platform/sendgrid/test', to ? { to } : {});
  if (!data?.success) throw new Error(data?.error || 'SendGrid test failed');
  return data;
}

export async function clearPlatformSendGridSettings() {
  const data = await adminCall('/api/admin/platform/sendgrid/clear');
  if (!data?.success) throw new Error(data?.error || 'Failed to disconnect SendGrid');
  return data;
}
